import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ApiService } from '../../services/api.service';
import {
  EDIT_THIRD_NETWORK_DETAIL,
  EDIT_THIRD_NETWORK_DETAIL_SUCCESS,
  RETRIEVE_ADD_ANAGRAPHIC,
  RETRIEVE_ADD_ANAGRAPHIC_SUCCESS,
  RETRIEVE_ANAGRAPHIC,
  RETRIEVE_ANAGRAPHIC_SUCCESS,
  RETRIEVE_DOCUMENTS,
  RETRIEVE_DOCUMENTS_SUCCESS,
  RETRIEVE_INTERFACE_MONITORING_CRM,
  RETRIEVE_INTERFACE_MONITORING_SAP,
  RETRIEVE_INTERFACE_MONITORING_DASHBOARD,
  RETRIEVE_INTERFACE_MONITORING_SUCCESS,
  RETRIEVE_OPERATION_HISTORY,
  RETRIEVE_OPERATION_HISTORY_SUCCESS,
  RETRIEVE_CRMO_DETAIL,
  RETRIEVE_CRMO_DETAIL_SUCCESS,
  RETRIEVE_RISOTTOMETTI_CRMO,
  RETRIEVE_RISOTTOMETTI_CRMO_ERROR,
  RETRIEVE_THIRD_NETWORK_DETAIL,
  RETRIEVE_THIRD_NETWORK_DETAIL_SUCCESS,
  RETRIEVE_SAP_DETAIL,
  RETRIEVE_DASHBOARD_DETAIL,
  RETRIEVE_DASHBOARD_DETAIL_SUCCESS,
  RETRIEVE_RISOTTOMETTI_SAP,
  RETRIEVE_SAP_DETAIL_SUCCESS,
  RETRIEVE_RISOTTOMETTI_SAP_ERROR,
  RETRIEVE_INTERFACE_HISTORY_CRM,
  RETRIEVE_INTERFACE_HISTORY_CRM_SUCCESS,
  DOWNLOAD_TEMPLATE_PRECOMPILED,
  RETRIEVE_OPERATION_PROGRESSIVE_SUCCESS,
  RETRIEVE_OPERATION_PROGRESSIVE,
  UPLOAD_FILE_NEW_OPERATION,
  UPLOAD_FILE_NEW_OPERATION_SUCCESS,
  RETRIEVE_MAL,
  RETRIEVE_MAL_SUCCESS,
  RETRIEVE_RAM,
  RETRIEVE_RAM_SUCCESS,
  RETRIEVE_CD,
  RETRIEVE_CD_SUCCESS,
  RETRIEVE_POINTS_LIST_SUCCESS,
  RETRIEVE_POINTS_LIST,
  DOWNLOAD_REPORT_POINTS_MANAGEMENT,
  CHANGE_STATUS,
  CHANGE_STATUS_SUCCESS,
  DOWNLOAD_MASSIVE_ACTIVATION_PRECOMPILED,
  UPLOAD_FILE_MASSIVE_ACTIVATION,
  UPLOAD_FILE_MASSIVE_ACTIVATION_SUCCESS,
  CONFIRM_FILE_MASSIVE_ACTIVATION,
  CONFIRM_FILE_MASSIVE_ACTIVATION_SUCCESS,
  RETRIEVE_GESTIONE_PUNTOPOSTE,
  RETRIEVE_GESTIONE_PUNTOPOSTE_SUCCESS,
  RETRIEVE_CMP_LIST,
  RETRIEVE_CMP_LIST_SUCCESS,
  RETRIEVE_AUDIT,
  RETRIEVE_CP,
  RETRIEVE_CP_SUCCESS,
  RETRIEVE_REPORT_GIACENZE_LIST_SUCCESS,
  RETRIEVE_REPORT_GIACENZE_LIST,
  RETRIEVE_REPORT_GIACENZE_XLS,
  DOWNLOAD_MIG2,
  RETRIEVE_INTERFACE_HISTORY_SAP,
  RETRIEVE_INTERFACE_HISTORY_SAP_SUCCESS,
  RETRIEVE_REPORT_GIACENZE_LOCKER_LIST,
  RETRIEVE_REPORT_GIACENZE_LOCKER_LIST_SUCCESS,
  RETRIEVE_REPORT_GIACENZE_LOCKER_XLS,
  RETRIEVE_RISOTTOMETTI_DASHBOARD,
  RETRIEVE_RISOTTOMETTI_DASHBOARD_ERROR,
  RETRIEVE_INTERFACE_HISTORY_DASHBOARD,
  RETRIEVE_INTERFACE_HISTORY_DASHBOARD_SUCCESS,
  RETRIEVE_STORICO_ICON,
  RETRIEVE_STORICO_ICON_SUCCESS,
  CHANGE_STATUS_PPS,
  CHANGE_STATUS_PPS_SUCCESS,
  DOWNLOAD_PREACTIVATION_PRECOMPILED,
  UPLOAD_FILE_PREACTIVATION,
  UPLOAD_FILE_PREACTIVATION_SUCCESS,
  CONFIRM_FILE_PREACTIVATION,
  CONFIRM_FILE_PREACTIVATION_SUCCESS,
  DOWNLOAD_MASSIVE_PRE_ACTIVATION_PRECOMPILED,
  ATTIVAZIONE_FORZATA_SERVIZI,
  ATTIVAZIONE_FORZATA_SERVIZI_SUCCESS,
  ATTIVAZIONE_FORZATA_SERVIZI_FAILURE,
  CHECK_ATTIVAZIONE_SERVIZI_FORZATA,
  CHECK_ATTIVAZIONE_SERVIZI_FORZATA_SUCCESS,
  UPLOAD_FILE_FORCE_MASSIVE_ACTIVATION_SERVICE_SUCCESS,
  UPLOAD_FILE_FORCE_MASSIVE_SERVICE_ACTIVATION,
  CONFIRM_FILE_FORCE_MASSIVE_SERVICE_ACTIVATION,
  CONFIRM_FILE_FORCE_MASSIVE_SERVICE_ACTIVATION_SUCCESS,
  UPLOAD_FILE_CARICAMENTO_MASSIVO_FERIE,
  UPLOAD_FILE_CARICAMENTO_MASSIVO_FERIE_SUCCESS,
  CONFIRM_CARICAMENTO_FILE_MASSIVO_FERIE,
  CONFIRM_CARICAMENTO_FILE_MASSIVO_FERIE_SUCCESS,
  UPLOAD_FILE_CARICAMENTO_MASSIVO_GESTIONE_UTENZE,
  UPLOAD_FILE_CARICAMENTO_MASSIVO_GESTIONE_UTENZE_SUCCESS,
  CONFIRM_CARICAMENTO_FILE_MASSIVO_GESTIONE_UTENZE_SUCCESS,
  CONFIRM_CARICAMENTO_FILE_MASSIVO_GESTIONE_UTENZE,
  UPDATE_CAMPI_OBBLIGATORI_UTENTE,
  UPDATE_CAMPI_OBBLIGATORI_UTENTI_SUCCESS,
  UPDATE_CAMPI_OBBLIGATORI_UTENTE_FAILURE,
} from './anagraphic.actions';
import {
  catchError,
  forkJoin,
  map,
  mergeMap,
  of,
  switchMap,
  tap,
  throwError,
} from 'rxjs';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import {
  ResponseAggiuntaAnagrafica,
  ResponseAnagraphicManagement,
} from '../../interfaces/response-anagraphic-management';
import { ResponseReteTerzaDettaglio } from '../../interfaces/response-rete-terza-dettaglio';
import { ResponseInterfaceMonitoringCrm } from '../../interfaces/response-interface-monitoring-crm';
import { ResponseInterfaceMonitoringSap } from '../../interfaces/response-interface-monitoring-sap';
import { ResponseInterfaceMonitoringDashboard } from '../../interfaces/response-interface-monitoring-dashboard';
import { ResponseDocuments } from '../../interfaces/response-documents';
import {
  ResponseCRMO,
  ResponseSAP,
  ResponseDashboard,
} from '../../interfaces/response-monitoring-interface';
import {
  PayloadStoricoOperazioni,
  ResponseStoricoOperazioni,
} from '../../interfaces/response-operation-history';
import {
  ResponseInterfaceHistoryCrm,
  RetrieveInterfaceHistoryCrm,
} from '../../interfaces/response-interface-history-crm';
import {
  ADD_TOAST_NOTIFICATION,
  DOWNLOAD_FILE,
} from '../config/config.actions';
import { ResponseOperazioniProgressivo } from '../../interfaces/response-operation-progressive';
import {
  IResponseCd,
  IResponseMal,
  IResponseRam,
} from '../../interfaces/mal-ram-cd';
import {
  IResponseCambioStato,
  IResponseCambioStatoPps,
  IResponseListaGestionePunti,
  ISingleObjectGestionePunti,
} from '../../interfaces/points-management';
import {
  IResponseConfermaCaricamentoAttivazioneMassiva,
  IResponseUploadAttivazioneMassiva,
} from '../../interfaces/attivazione-massiva';
import { RetrieveGestionPuntoPoste } from '../../interfaces/retrieve-gestione-puntoposte';
import { ResponseCMP, ResponseCP } from '../../interfaces/puntoposte-detail';
import dayjs from 'dayjs';
import { IResponseReportGiacenzeList } from '../../interfaces/report-giacenze';
import { SET_COD_TIPOLOGIA_CP } from '../login/login.actions';
import { NotificationTypeEnum, today } from '@poste-click-connect/shared-ui';
import {
  IPayloadStoricoSap,
  IResponseStoricoSap,
} from '../../interfaces/response-interface-history-sap';

import {
  IPayloadStoricoDashboard,
  IResponseStoricoDashboard,
} from '../../interfaces/response-interface-history-dashboard';

import { PersistenceService } from '../../services/persistence.service';
import {
  RetrieveInterfaceMonitoringCrm,
  RetrieveInterfaceMonitoringSap,
  RetrieveInterfaceMonitoringDashboard,
} from '../../interfaces/retrieve-interface-monitoring';
import { IResponseReportGiacenzeLockerList } from '../../interfaces/report-giacenze-locker';
import {
  IPayloadStoricoIcon,
  IResponseStoricoIcon,
} from '../../interfaces/monitoraggio-storico-icon';
import {
  IResponseConfermaCaricamentoPreAttivazione,
  IResponseUploadPreAttivazione,
} from '../../interfaces/forzatura-preattivazione';
import {
  IResponseConfermaCaricamentoFileFerieMassivo,
  IResponseUploadFileFerieMassivo,
} from '../../interfaces/upload-ferie-response';
import {
  IResponseConfermaCaricamentoFileGestioneUtenzeMassivo,
  IResponseUploadFileGestioneUtenzeMassivo,
} from '../../interfaces/upload-gestione-utenze-response';

@Injectable()
export class AnagraphicEffects {
  retrieveAnagraphic$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RETRIEVE_ANAGRAPHIC),
      switchMap(() => {
        return this.api.retrieveAnagrafica();
      }),
      mergeMap((responseAnagrafica: ResponseAnagraphicManagement) => {
        return [
          RETRIEVE_ANAGRAPHIC_SUCCESS({
            responseAnagrafica,
          }),
        ];
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  retrieveAddAnagraphic$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RETRIEVE_ADD_ANAGRAPHIC),
      switchMap(({ payload }) => this.api.retrieveAggiuntaAnagrafica(payload)),
      mergeMap((responseAggiuntaAnagrafica: ResponseAggiuntaAnagrafica) => {
        return [
          RETRIEVE_ADD_ANAGRAPHIC_SUCCESS({
            responseAggiuntaAnagrafica,
          }),
        ];
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    )
  );

  retrieveThirdNetworkDetail$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RETRIEVE_THIRD_NETWORK_DETAIL),
      switchMap(({ payload }: { payload: string }) => {
        return this.api.retrieveReteTerzaDettaglio(payload);
      }),
      mergeMap((responseReteTerzaDettaglio: ResponseReteTerzaDettaglio) => {
        return [
          SET_COD_TIPOLOGIA_CP({
            codTipologiaCp: responseReteTerzaDettaglio.reteTerza.codTipologiaRT,
          }),
          RETRIEVE_THIRD_NETWORK_DETAIL_SUCCESS({
            responseReteTerzaDettaglio,
          }),
        ];
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  retrieveEditThirdNetworkDetail$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(EDIT_THIRD_NETWORK_DETAIL),
      switchMap(({ payload }) => this.api.editReteTerzaDettaglio(payload)),
      mergeMap(
        (responseModificaReteTerzaDettaglio: ResponseAggiuntaAnagrafica) => {
          return [
            EDIT_THIRD_NETWORK_DETAIL_SUCCESS({
              responseModificaReteTerzaDettaglio,
            }),
          ];
        }
      ),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  retrieveInterfaceMonitoringCrm$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RETRIEVE_INTERFACE_MONITORING_CRM),
      switchMap(({ payload }) => {
        return forkJoin({
          payload: of(payload),
          responseInterfaceMonitoring: this.api.interfaceMonitoringCrm(payload),
        });
      }),
      mergeMap(
        ({
          payload,
          responseInterfaceMonitoring,
        }: {
          payload: RetrieveInterfaceMonitoringCrm;
          responseInterfaceMonitoring: ResponseInterfaceMonitoringCrm;
        }) => {
          this.persistence.setMonitoringInterfaceFilters(payload.operazione);
          this.persistence.setMonitoringInterfaceList({
            result: responseInterfaceMonitoring,
          });

          return [
            RETRIEVE_INTERFACE_MONITORING_SUCCESS({
              responseInterfaceMonitoring,
            }),
          ];
        }
      ),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  retrieveInterfaceMonitoringSap$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RETRIEVE_INTERFACE_MONITORING_SAP),
      switchMap(({ payload }) => {
        return forkJoin({
          payload: of(payload),
          responseInterfaceMonitoring: this.api.interfaceMonitoringSap(payload),
        });
      }),
      mergeMap(
        ({
          payload,
          responseInterfaceMonitoring,
        }: {
          payload: RetrieveInterfaceMonitoringSap;
          responseInterfaceMonitoring: ResponseInterfaceMonitoringSap;
        }) => {
          this.persistence.setMonitoringInterfaceFilters(payload.operazione);
          this.persistence.setMonitoringInterfaceList({
            result: responseInterfaceMonitoring,
          });

          return [
            RETRIEVE_INTERFACE_MONITORING_SUCCESS({
              responseInterfaceMonitoring,
            }),
          ];
        }
      ),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });
  retrieveInterfaceMonitoringDashboard$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RETRIEVE_INTERFACE_MONITORING_DASHBOARD),
      switchMap(({ payload }) => {
        return forkJoin({
          payload: of(payload),
          responseInterfaceMonitoring:
            this.api.interfaceMonitoringDashboard(payload),
        });
      }),
      mergeMap(
        ({
          payload,
          responseInterfaceMonitoring,
        }: {
          payload: RetrieveInterfaceMonitoringDashboard;
          responseInterfaceMonitoring: ResponseInterfaceMonitoringDashboard;
        }) => {
          payload.operazione;
          this.persistence.setMonitoringInterfaceFiltersDashboard(
            payload.operazione
          );
          this.persistence.setMonitoringInterfaceList({
            result: responseInterfaceMonitoring,
          });

          return [
            RETRIEVE_INTERFACE_MONITORING_SUCCESS({
              responseInterfaceMonitoring,
            }),
          ];
        }
      ),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });
  retrieveDocuments$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RETRIEVE_DOCUMENTS),
      switchMap(({ payload }) => this.api.retrieveDocuments(payload)),
      mergeMap((responseDocuments: ResponseDocuments) => {
        return [
          RETRIEVE_DOCUMENTS_SUCCESS({
            responseDocuments,
          }),
        ];
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });
  retrieveCrmoDetail$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RETRIEVE_CRMO_DETAIL),
      switchMap(({ idOperazione }) =>
        this.api.retrieveDetailCrmo(idOperazione)
      ),
      mergeMap((responseCrmo: ResponseCRMO) => {
        return [
          RETRIEVE_CRMO_DETAIL_SUCCESS({
            responseCrmo,
          }),
        ];
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  retrieveRisottomettiCrm$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RETRIEVE_RISOTTOMETTI_CRMO),
      switchMap(({ payload }) => this.api.retrieveRisottomettiCrm(payload)),
      mergeMap((responseRisottomettiCrm: ResponseCRMO) => {
        return [
          RETRIEVE_RISOTTOMETTI_CRMO_ERROR({
            responseRisottomettiCrm,
          }),
        ];
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  retrieveOperationHistory$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RETRIEVE_OPERATION_HISTORY),
      switchMap(({ payload }) => {
        return forkJoin({
          payload: of(payload),
          responseStoricoOperazioni:
            this.api.retrieveStoricoOperazioni(payload),
        });
      }),
      mergeMap(
        ({
          payload,
          responseStoricoOperazioni,
        }: {
          payload: PayloadStoricoOperazioni;
          responseStoricoOperazioni: ResponseStoricoOperazioni;
        }) => {
          this.persistence.setHistoryFilters(payload.operazione);
          this.persistence.setHistoryList({
            result: responseStoricoOperazioni,
          });

          return [
            RETRIEVE_OPERATION_HISTORY_SUCCESS({
              responseStoricoOperazioni,
            }),
          ];
        }
      ),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  retrieveSapDetail$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RETRIEVE_SAP_DETAIL),
      switchMap(({ idOperazione }) => this.api.retrieveDetailSap(idOperazione)),
      mergeMap((responseSap: ResponseSAP) => {
        return [
          RETRIEVE_SAP_DETAIL_SUCCESS({
            responseSap,
          }),
        ];
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  retrieveDashboardDetail$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RETRIEVE_DASHBOARD_DETAIL),
      switchMap(({ idOperazione }) =>
        this.api.retrieveDetailDashboard(idOperazione)
      ),
      mergeMap((responseDashboard: ResponseDashboard) => {
        return [
          RETRIEVE_DASHBOARD_DETAIL_SUCCESS({
            responseDashboard,
          }),
        ];
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  downloadTemplateOperation$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(DOWNLOAD_TEMPLATE_PRECOMPILED),
      switchMap(
        ({
          payload,
          idOperazione,
          reteTerza,
        }: {
          payload: any;
          idOperazione: string;
          reteTerza: string;
          progressiveValue: string;
        }) => {
          return this.api.downloadTemplateNuovaoperazionePrecompilato(
            payload,
            idOperazione,
            reteTerza
          );
        }
      ),
      mergeMap((response: HttpResponse<Blob>) => {
        if (!(response.body as unknown as ArrayBuffer)?.byteLength) {
          return [
            ADD_TOAST_NOTIFICATION({
              notificationMessage: {
                type: NotificationTypeEnum.ERROR,
                description: 'Nessun Punto Poste rispetta i criteri di ricerca',
              },
            }),
          ];
        }
        const fileName = response.headers.get('content-disposition');

        return [
          DOWNLOAD_FILE({
            file: response.body as Blob,
            fileName: fileName?.substr(17, 50) || 'template_nuova_operazione',
            blobType: 'text/csv;charset=utf-8',
          }),
        ]; // fileName.substr(17, 50) preso dal vecchio BO
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  retrieveOperazioniProgressivo$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RETRIEVE_OPERATION_PROGRESSIVE),
      switchMap(() => this.api.retrieveOperazioniProgressivo()),
      mergeMap(
        (responseOperazioniProgressivo: ResponseOperazioniProgressivo) => {
          return [
            RETRIEVE_OPERATION_PROGRESSIVE_SUCCESS({
              responseOperazioniProgressivo,
            }),
          ];
        }
      ),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  retrieveRisottomettiSap$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RETRIEVE_RISOTTOMETTI_SAP),
      switchMap(({ payload }) => this.api.retrieveRisottomettiSap(payload)),
      mergeMap((responseRisottomettiSap: ResponseSAP) => {
        return [
          RETRIEVE_RISOTTOMETTI_SAP_ERROR({
            responseRisottomettiSap,
          }),
        ];
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  retrieveRisottomettiDashboard$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RETRIEVE_RISOTTOMETTI_DASHBOARD),
      switchMap(({ payload }) =>
        this.api.retrieveRisottomettiDashboard(payload)
      ),
      mergeMap((responseRisottomettiDashboard: ResponseDashboard) => {
        return [
          RETRIEVE_RISOTTOMETTI_DASHBOARD_ERROR({
            responseRisottomettiDashboard,
          }),
        ];
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  retrieveInterfaceHistoryCrm$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RETRIEVE_INTERFACE_HISTORY_CRM),
      switchMap(({ payload }) => {
        return forkJoin({
          payload: of(payload),
          responseInterfaceHistory: this.api.interfaceHistoryCrm(payload),
        });
      }),
      mergeMap(
        ({
          payload,
          responseInterfaceHistory,
        }: {
          payload: RetrieveInterfaceHistoryCrm;
          responseInterfaceHistory: ResponseInterfaceHistoryCrm;
        }) => {
          this.persistence.setHistoryInterfaceFilters(payload.operazione);
          this.persistence.setHistoryInterfaceList({
            result: responseInterfaceHistory,
          });

          return [
            RETRIEVE_INTERFACE_HISTORY_CRM_SUCCESS({
              responseInterfaceHistory,
            }),
          ];
        }
      ),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  retrieveInterfaceHistorySap$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RETRIEVE_INTERFACE_HISTORY_SAP),
      switchMap(({ payload }) => {
        return forkJoin({
          payload: of(payload),
          responseStoricoSap: this.api.interfaceHistorySap(payload),
        });
      }),
      mergeMap(
        ({
          payload,
          responseStoricoSap,
        }: {
          payload: IPayloadStoricoSap;
          responseStoricoSap: IResponseStoricoSap;
        }) => {
          this.persistence.setHistoryInterfaceFilters(payload.operazione);
          this.persistence.setHistoryInterfaceList({
            result: responseStoricoSap,
          });
          return [
            RETRIEVE_INTERFACE_HISTORY_SAP_SUCCESS({
              responseStoricoSap,
            }),
          ];
        }
      ),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  retrieveInterfaceHistoryDashboard$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RETRIEVE_INTERFACE_HISTORY_DASHBOARD),
      switchMap(({ payload }) => {
        return forkJoin({
          payload: of(payload),
          responseStoricoDashboard: this.api.interfaceHistoryDashboard(payload),
        });
      }),
      mergeMap(
        ({
          payload,
          responseStoricoDashboard,
        }: {
          payload: IPayloadStoricoDashboard;
          responseStoricoDashboard: IResponseStoricoDashboard;
        }) => {
          this.persistence.setHistoryInterfaceFiltersDashboard(
            payload.operazione
          );
          this.persistence.setHistoryInterfaceList({
            result: responseStoricoDashboard,
          });
          return [
            RETRIEVE_INTERFACE_HISTORY_DASHBOARD_SUCCESS({
              responseStoricoDashboard,
            }),
          ];
        }
      ),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  uploadNuovaOperazioneFile$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(UPLOAD_FILE_NEW_OPERATION),
      switchMap(
        ({
          payload,
          idOperazione,
          reteTerza,
          isPut,
        }: {
          payload: any;
          idOperazione: string;
          reteTerza: string;
          isPut: boolean;
        }) => {
          return this.api.uploadNewOperationfile(
            payload,
            idOperazione,
            reteTerza,
            isPut
          );
        }
      ),
      mergeMap((responseNuovaOperazioneFile: any) => {
        return [
          UPLOAD_FILE_NEW_OPERATION_SUCCESS({
            responseNuovaOperazioneFile,
          }),
        ];
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  retrieveMal$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RETRIEVE_MAL),
      switchMap(() => this.api.retriveMal()),
      mergeMap((responseMal: IResponseMal) => {
        return [
          RETRIEVE_MAL_SUCCESS({
            responseMal,
          }),
        ];
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  retrieveRam$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RETRIEVE_RAM),
      switchMap(({ payload }) => this.api.retriveRam(payload)),
      mergeMap((responseRam: IResponseRam) => {
        return [
          RETRIEVE_RAM_SUCCESS({
            responseRam,
          }),
        ];
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  retrieveCd$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RETRIEVE_CD),
      switchMap(({ payload }) => this.api.retriveCd(payload)),
      mergeMap((responseCd: IResponseCd) => {
        return [
          RETRIEVE_CD_SUCCESS({
            responseCd,
          }),
        ];
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  retrieveListaGestionePunti$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RETRIEVE_POINTS_LIST),
      switchMap(({ payload }) => this.api.retriveListaGestionePunti(payload)),
      mergeMap((responseListaGestionePunti: IResponseListaGestionePunti) => {
        return [
          RETRIEVE_POINTS_LIST_SUCCESS({
            responseListaGestionePunti,
          }),
        ];
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  downloadReportGestionePunti$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(DOWNLOAD_REPORT_POINTS_MANAGEMENT),
      switchMap(
        ({
          payload,
          isApt,
        }: {
          payload: ISingleObjectGestionePunti[];
          isApt: boolean;
        }) => {
          return this.api.downloadReportGestionePunti(payload, isApt);
        }
      ),
      map((response: any) => {
        // const fileName = response.headers.get('content-disposition');

        return DOWNLOAD_FILE({
          file: response.body,
          fileName: 'reportAnagrafica.xlsx',
        }); // fileName.substr(17, 50) preso dal vecchio BO
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  cambioStatoPuntoPoste$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(CHANGE_STATUS),
      switchMap(({ payload }) =>
        this.api.retriveCambioStatoPuntoPoste(payload).pipe(
          mergeMap((responseCambioStato: IResponseCambioStato) => {
            let responseCambioStatoWithPayload = {
              responseCambioStato,
              payload,
            };
            return [
              CHANGE_STATUS_SUCCESS({
                responseCambioStatoWithPayload,
              }),
            ];
          }),
          catchError((error: HttpErrorResponse) => throwError({ error }))
        )
      )
    );
  });

  cambioStatoPuntoPostePPS$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(CHANGE_STATUS_PPS),
      switchMap(({ payload }) =>
        this.api.retriveCambioStatoPuntoPostePps(payload).pipe(
          mergeMap((responseCambioStato: IResponseCambioStatoPps) => {
            let responseCambioStatoPpsWithPayload = {
              responseCambioStato,
              payload,
            };
            return [
              CHANGE_STATUS_PPS_SUCCESS({
                responseCambioStatoPpsWithPayload,
              }),
            ];
          }),
          catchError((error: HttpErrorResponse) => throwError({ error }))
        )
      )
    );
  });

  downloadAttivazioneMassivaPrecompilato$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(DOWNLOAD_MASSIVE_ACTIVATION_PRECOMPILED),
      switchMap(
        ({
          payload,
          reteTerza,
        }: {
          payload: { action4: string };
          reteTerza: string;
        }) => {
          return this.api.downloadPreAttivazioneMassivaPrecompilato(
            payload,
            reteTerza
          );
        }
      ),
      map((response: any) => {
        const fileName = response.headers.get('content-disposition');

        return DOWNLOAD_FILE({
          file: response.body,
          fileName:
            fileName?.substr(17, 50) || 'precompilato_attivazione_massiva',
        }); // fileName.substr(17, 50) preso dal vecchio BO
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  uploadAttivazioneMassivaFile$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(UPLOAD_FILE_MASSIVE_ACTIVATION),
      switchMap(({ payload }: { payload: FormData }) => {
        return this.api.uploadAttivazioneMassivafile(payload);
      }),
      mergeMap(
        (responseAttivazioneMassivaFile: IResponseUploadAttivazioneMassiva) => {
          return [
            UPLOAD_FILE_MASSIVE_ACTIVATION_SUCCESS({
              responseAttivazioneMassivaFile,
            }),
          ];
        }
      ),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  confirmAttivazioneMassivaFile$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(CONFIRM_FILE_MASSIVE_ACTIVATION),
      switchMap(({ payload }) => {
        return this.api.confermaAttivazioneMassivafile(payload);
      }),
      mergeMap(
        (
          responseConfermaAttivazioneMassivaFile: IResponseConfermaCaricamentoAttivazioneMassiva
        ) => {
          return [
            CONFIRM_FILE_MASSIVE_ACTIVATION_SUCCESS({
              responseConfermaAttivazioneMassivaFile,
            }),
          ];
        }
      ),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  downloadPreattivazionePrecompilato$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(DOWNLOAD_PREACTIVATION_PRECOMPILED),
      switchMap(
        ({
          payload,
          reteTerza,
        }: {
          payload: { action4: string };
          reteTerza: string;
        }) => {
          return this.api.downloadPreAttivazionePrecompilato(
            payload,
            reteTerza
          );
        }
      ),
      map((response: any) => {
        let fileName = response.headers.get('content-disposition');

        if (fileName && fileName.lastIndexOf('_') >= 0) {
          fileName =
            'Forzatura_attivazione' +
            fileName.substring(fileName.lastIndexOf('_'));
        } else {
          fileName = 'precompilato_forzatura_attivazione';
        }

        return DOWNLOAD_FILE({
          file: response.body,
          fileName: fileName,
        }); // fileName.substr(17, 50) preso dal vecchio BO
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  downloadPreattivazioneMassivaPrecompilato$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(DOWNLOAD_MASSIVE_PRE_ACTIVATION_PRECOMPILED),
      switchMap(
        ({
          payload,
          reteTerza,
        }: {
          payload: { action4: string };
          reteTerza: string;
        }) => {
          return this.api.downloadAttivazioneMassivaPrecompilato(
            payload,
            reteTerza
          );
        }
      ),
      map((response: any) => {
        let fileName = response.headers.get('content-disposition');

        if (fileName && fileName.lastIndexOf('_') >= 0) {
          fileName =
            'Pre_attivazione_massiva' +
            fileName.substring(fileName.lastIndexOf('_'));
        } else {
          const now = new Date();
          const nowSuffix =
            now.getFullYear().toString().padStart(4, '0') +
            (now.getMonth() + 1).toString().padStart(2, '0') +
            now.getDate().toString().padStart(2, '0') +
            now.getHours().toString().padStart(2, '0') +
            now.getMinutes().toString().padStart(2, '0');

          fileName = 'Pre_attivazione_massiva_' + nowSuffix;
        }

        return DOWNLOAD_FILE({
          file: response.body,
          fileName: fileName,
        }); // fileName.substr(17, 50) preso dal vecchio BO
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  uploadPreattivazioneFile$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(UPLOAD_FILE_PREACTIVATION),
      switchMap(({ payload }: { payload: FormData }) => {
        return this.api.uploadPreAttivazioneFile(payload);
      }),
      mergeMap((responsePreAttivazioneFile: IResponseUploadPreAttivazione) => {
        return [
          UPLOAD_FILE_PREACTIVATION_SUCCESS({
            responsePreAttivazioneFile,
          }),
        ];
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  confirmPreattivazioneFile$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(CONFIRM_FILE_PREACTIVATION),
      switchMap(({ payload }) => {
        return this.api.confermaPreAttivazioneFile(payload);
      }),
      mergeMap(
        (
          responseConfermaPreAttivazioneFile: IResponseConfermaCaricamentoPreAttivazione
        ) => {
          return [
            CONFIRM_FILE_PREACTIVATION_SUCCESS({
              responseConfermaPreAttivazioneFile,
            }),
          ];
        }
      ),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  retrieveGestionPuntoPoste$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RETRIEVE_GESTIONE_PUNTOPOSTE),
      switchMap(({ idPuntoPoste }) =>
        this.api.retrieveGestionePuntoPoste(idPuntoPoste)
      ),
      mergeMap((responsePuntoPoste: RetrieveGestionPuntoPoste) => {
        return [
          RETRIEVE_GESTIONE_PUNTOPOSTE_SUCCESS({
            responsePuntoPoste,
          }),
        ];
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  retrieveCMPList$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RETRIEVE_CMP_LIST),
      switchMap(() => this.api.retrieveCMPList()),
      mergeMap((responseCMP: ResponseCMP) => {
        return [
          RETRIEVE_CMP_LIST_SUCCESS({
            responseCMP,
          }),
        ];
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  retrieveCP$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RETRIEVE_CP),
      switchMap(({ payload }) => this.api.retrieveCP(payload)),
      mergeMap((responseCP: ResponseCP) => {
        return [
          RETRIEVE_CP_SUCCESS({
            responseCP,
          }),
        ];
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  retrieveAudit$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RETRIEVE_AUDIT),
      switchMap(({ idPuntoPoste }) => this.api.retrieveAudit(idPuntoPoste)),
      map((response: any) => {
        const todaydate = dayjs(today()).format('YYYYMMDDHHmmss');

        const fileName = `VariazioniPuntoPoste_${todaydate}.xlsx`;

        return DOWNLOAD_FILE({
          file: response.body,
          fileName: fileName || 'audit',
        });
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  retrieveReportGiacenzeList$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RETRIEVE_REPORT_GIACENZE_LIST),
      switchMap(({ idPuntoPoste }) =>
        this.api.retrieveReportGiacenzeList(idPuntoPoste)
      ),
      map((responseReportGiacenzeList: IResponseReportGiacenzeList) => {
        return RETRIEVE_REPORT_GIACENZE_LIST_SUCCESS({
          responseReportGiacenzeList,
        });
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  retrieveReportGiacenzeXls$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RETRIEVE_REPORT_GIACENZE_XLS),
      switchMap(({ payload }) => this.api.retrieveReportGiacenzeXls(payload)),
      map((response: HttpResponse<Blob>) => {
        return DOWNLOAD_FILE({
          file: response.body as Blob,
          fileName: 'reportGiacenze.xlsx',
        });
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  retrieveReportGiacenzeLockerList$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RETRIEVE_REPORT_GIACENZE_LOCKER_LIST),
      switchMap(({ idPuntoPosteLocker }) =>
        this.api.retrieveReportGiacenzeLockerList(idPuntoPosteLocker)
      ),
      map(
        (
          responseReportGiacenzeLockerList: IResponseReportGiacenzeLockerList
        ) => {
          return RETRIEVE_REPORT_GIACENZE_LOCKER_LIST_SUCCESS({
            responseReportGiacenzeLockerList,
          });
        }
      ),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  retrieveReportGiacenzeLockerXls$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RETRIEVE_REPORT_GIACENZE_LOCKER_XLS),
      switchMap(({ payload }) =>
        this.api.retrieveReportGiacenzeLockerXls(payload)
      ),
      map((response: HttpResponse<Blob>) => {
        return DOWNLOAD_FILE({
          file: response.body as Blob,
          fileName: 'reportGiacenzeLocker.xlsx',
        });
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  downloadMig2$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(DOWNLOAD_MIG2),
      switchMap(({ payload }: { payload: any }) => {
        return this.api.downloadMig2(payload);
      }),
      map((response: any) => {
        const fileName =
          'MIG2_' + dayjs(new Date()).format('YYYYMMDDHHmmss') + '.xlsx';
        return DOWNLOAD_FILE({
          file: response.body,
          fileName: fileName,
        });
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  retrieveStoricoIcon$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RETRIEVE_STORICO_ICON),
      switchMap(({ payload }: { payload: IPayloadStoricoIcon }) =>
        this.api.retrieveStoricoIcon(payload)
      ),
      map((responseStoricoIcon: IResponseStoricoIcon) => {
        return RETRIEVE_STORICO_ICON_SUCCESS({
          responseStoricoIcon,
        });
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  //Attivazione forzata servizi
  attivazioneForzataServizi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ATTIVAZIONE_FORZATA_SERVIZI),
      switchMap(({ idPuntoPoste, servizio }) =>
        this.api.attivazioneForzataServizio(idPuntoPoste, servizio).pipe(
          map((response) => {
            if (response.esito === 'OK') {
              return ATTIVAZIONE_FORZATA_SERVIZI_SUCCESS({
                responseAttivazioneForzata: response,
              });
            } else {
              return ATTIVAZIONE_FORZATA_SERVIZI_FAILURE({
                error:
                  response.errorDescr ||
                  'Errore durante attivazione forzata del punto poste',
              });
            }
          }),
          catchError((error) =>
            of(ATTIVAZIONE_FORZATA_SERVIZI_FAILURE({ error }))
          )
        )
      )
    )
  );

  //Considero solo il primo elemento ritornato, ne basta almeno uno per attivare il bottone
  checkAttivazioneForzataServizi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CHECK_ATTIVAZIONE_SERVIZI_FORZATA),
      switchMap(({ idUnivoco }) =>
        this.api.attivazioneForzataServiziCheck(idUnivoco).pipe(
          map((response) =>
            CHECK_ATTIVAZIONE_SERVIZI_FORZATA_SUCCESS({
              stato:
                response.attivazioniPPVOList[0]?.stato || 'NON DISPONIBILE',
            })
          ),
          catchError((error) =>
            of(
              ADD_TOAST_NOTIFICATION({
                notificationMessage: {
                  type: NotificationTypeEnum.ERROR,
                  description:
                    'Errore nel recupero dello stato di attivazione del punto poste',
                },
              })
            )
          )
        )
      )
    )
  );

  uploadForzaAttivazioneServiziMassivaFile$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(UPLOAD_FILE_FORCE_MASSIVE_SERVICE_ACTIVATION),
      switchMap(({ payload }: { payload: FormData }) => {
        return this.api.uploadForzaAttivazioneServiziMassivafile(payload);
      }),
      mergeMap(
        (
          responseForzaAttivazioneServiziMassivaFile: IResponseUploadAttivazioneMassiva
        ) => {
          return [
            UPLOAD_FILE_FORCE_MASSIVE_ACTIVATION_SERVICE_SUCCESS({
              responseForzaAttivazioneServiziMassivaFile,
            }),
          ];
        }
      ),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  confirmAttivazioneForzataServiziMassivaFile$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(CONFIRM_FILE_FORCE_MASSIVE_SERVICE_ACTIVATION),
      switchMap(({ payload }) => {
        return this.api.confermaAttivazioneForzataServiziMassivafile(payload);
      }),
      mergeMap(
        (
          responseConfermaAttivazioneForzataServiziMassivaFile: IResponseConfermaCaricamentoAttivazioneMassiva
        ) => {
          return [
            CONFIRM_FILE_FORCE_MASSIVE_SERVICE_ACTIVATION_SUCCESS({
              responseConfermaAttivazioneForzataServiziMassivaFile,
            }),
          ];
        }
      ),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  // Effetti per la gestione del caricamento del file delle ferie
  uploadFileCaricamentoMassivoFerie$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(UPLOAD_FILE_CARICAMENTO_MASSIVO_FERIE),
      switchMap(({ payload }: { payload: FormData }) => {
        return this.api.uploadFileCaricamentoMassivoFerie(payload);
      }),
      mergeMap((uploadFerieFileResponse: IResponseUploadFileFerieMassivo) => {
        console.log(
          'chiamata al servizio di upload ferie',
          uploadFerieFileResponse
        );
        return [
          UPLOAD_FILE_CARICAMENTO_MASSIVO_FERIE_SUCCESS({
            responseUploadFerieFile: uploadFerieFileResponse,
          }),
        ];
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  confirmCaricamentoFileMassivoFerie$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(CONFIRM_CARICAMENTO_FILE_MASSIVO_FERIE),
      switchMap(({ payload }) =>
        this.api.confermaCaricamentoFileMassivoFerie(payload).pipe(
          map(
            (
              responseConfermaCaricamentoMassivoFileFerie: IResponseConfermaCaricamentoFileFerieMassivo
            ) =>
              CONFIRM_CARICAMENTO_FILE_MASSIVO_FERIE_SUCCESS({
                responseConfermaCaricamentoMassivoFileFerie,
              })
          ),
          catchError((error: HttpErrorResponse) =>
            of(
              ADD_TOAST_NOTIFICATION({
                notificationMessage: {
                  type: NotificationTypeEnum.ERROR,
                  description: 'Errore nel caricamento del file delle ferie',
                },
              })
            )
          )
        )
      )
    );
  });

  // Effetti per la gestione del caricamento del file gestione utenze
  uploadFileCaricamentoMassivoGestioneUtenze$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(UPLOAD_FILE_CARICAMENTO_MASSIVO_GESTIONE_UTENZE),
      switchMap(({ payload }: { payload: FormData }) => {
        return this.api.uploadFileCaricamentoMassivoGestioneUtenze(payload);
      }),
      mergeMap(
        (
          uploadGestioneUtenzeFileResponse: IResponseUploadFileGestioneUtenzeMassivo
        ) => {
          console.log(
            'chiamata al servizio di upload gestione utenze',
            uploadGestioneUtenzeFileResponse
          );
          return [
            UPLOAD_FILE_CARICAMENTO_MASSIVO_GESTIONE_UTENZE_SUCCESS({
              responseUploadGestioneUtenzeFile:
                uploadGestioneUtenzeFileResponse,
            }),
          ];
        }
      ),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  confirmCaricamentoFileMassivoGestioneUtenze$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(CONFIRM_CARICAMENTO_FILE_MASSIVO_GESTIONE_UTENZE),
      switchMap(({ payload }) =>
        this.api.confermaCaricamentoFileMassivoGestioneUtenze(payload).pipe(
          map(
            (
              responseConfermaCaricamentoMassivoFileGestioneUtenze: IResponseConfermaCaricamentoFileGestioneUtenzeMassivo
            ) =>
              CONFIRM_CARICAMENTO_FILE_MASSIVO_GESTIONE_UTENZE_SUCCESS({
                responseConfermaCaricamentoMassivoFileGestioneUtenze,
              })
          ),
          catchError((error: HttpErrorResponse) =>
            of(
              ADD_TOAST_NOTIFICATION({
                notificationMessage: {
                  type: NotificationTypeEnum.ERROR,
                  description:
                    'Errore nel caricamento del file delle gestione utenze',
                },
              })
            )
          )
        )
      )
    );
  });

  updateCampiObbligatoriUtente$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UPDATE_CAMPI_OBBLIGATORI_UTENTE),
      switchMap(({ codiceFiscale, frazOrg, matricola }) =>
        this.api.updateCampiObbligatoriUtente(codiceFiscale, frazOrg, matricola).pipe(
          map((response) => {
            if (response.esito === 'OK') {
              return UPDATE_CAMPI_OBBLIGATORI_UTENTI_SUCCESS({
                responseUpdateCampiObbligatoriUtente: response,
              });
            } else {
              return UPDATE_CAMPI_OBBLIGATORI_UTENTE_FAILURE({
                error:
                  response.errorDescr ||
                  'Errore durante update dei campi obbligatori utente',
              });
            }
          }),
          catchError((error) =>
            of(UPDATE_CAMPI_OBBLIGATORI_UTENTE_FAILURE({ error }))
          )
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private api: ApiService,
    private persistence: PersistenceService
  ) {}
}
